"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = exports.setLocale = void 0;
var _commons = require("./commons");
var _locales = _interopRequireDefault(require("../locales"));
var i18nText = {};
var setLocale = exports.setLocale = function setLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  i18nText = _locales["default"][locale] || _locales["default"].en;
};
var translate = exports.translate = function translate(key, defaultValue) {
  return (0, _commons.getValue)(i18nText, key, defaultValue);
};